import { trackWithGoogleAnalytics } from '../../../../shared/analytics/shared/trackers/trackWithGoogleAnalytics';
import { IVehicle } from '../../../../shared/api/gateway/models/Vehicle';

export function setVehiclesAmount(vehicles: IVehicle[]) {
	trackWithGoogleAnalytics('set', 'user_properties', {
		vehicles_amount: vehicles.length,
	});
}
